// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__10G2a","description":"PatientConsentPreview_description__3S4iB"};